import {initializeApp,} from "firebase/app";
import {getMessaging, getToken, onMessage} from "firebase/messaging";

const VAPID_KEY = 'BKISV40xrn7jcOXaKy7pB4MBM4BrEJlsj5269mDXPpsnMySMdJJhjFlirdQYBUSNdlUaS4T1X7KE3JWfK0vTGe0'
const firebaseConfig = {
    apiKey: "AIzaSyAxWrl7X0AUsD2QS_j9NWasypDMlX7D7c8",
    authDomain: "kidsday-efbff.firebaseapp.com",
    projectId: "kidsday-efbff",
    storageBucket: "kidsday-efbff.appspot.com",
    messagingSenderId: "664633082602",
    appId: "1:664633082602:web:1a4811cf6735f00e8a4d93",
    measurementId: "G-KHHCR5YG65"
};

export const subscribeUserToWebNotifications = () => {
    const firebaseApp = initializeApp(firebaseConfig);
    const messaging = getMessaging(firebaseApp);
    getToken(messaging, {vapidKey: VAPID_KEY})
        .then((currentToken) => saveUserSubscription(currentToken))
        .catch((err) => console.info('An error occurred while enabling notifications. Please restart and try again! '));

    onMessage(function (payload) {
        const title = payload.notification.title;
        const options = {
            body: payload.notification.body,
            icon: payload.notification.icon,
            badge: '/img/notifications/badge-icon-org-128.png',
        };
        new Notification(title, options);
    });
}

const saveUserSubscription = (token) => {
    if (token) {
        axios.post(`/user/subscribe-to-notification`, {token})
    }
}
